<template>
  <div class="convey-statement">
    <slot name="statement">
      {{ statement }}
    </slot>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ConveyStatement",
  props: {
    statement: String
  }
};
</script>

<style lang="scss">
.convey-statement {
  font-weight: 400;
}
</style>
